// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import { imServerStore } from './store/imServerStore.js';
// axios
import http from '@/common/http.js';
Vue.prototype.$http = http;
// ak
import ak from '@/common/ak.js';
Vue.prototype.$ak = ak;
// element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// font-awesome
import 'font-awesome/css/font-awesome.min.css'
// i18n
import i18n from './i18n'

// config
Vue.config.productionTip = false;
// console.log('VUE_APP_BASE_API:', process.env.VUE_APP_BASE_API); // 应该输出你在 .env 文件中定义的值
// console.log('VUE_APP_BASE_URL:', process.env.VUE_APP_BASE_URL); // 应该输出 http://localhost:8080
/* eslint-disable no-new */
// window.polkVue = new Vue({
//     el: '#app',
//     router,
//     components: { App },
//     store: {
//         imServerStore: imServerStore
//     },
//     template: '<App/>'
// });
new Vue({
    el: '#app',
    router,
    i18n,
    store: {
          imServerStore: imServerStore
    },
    render: h => h(App)
  })
